import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import authService from '../services/authService';

const languages = [
  { key: 'el', label: 'Ελληνικά', flag: '🇬🇷' },
  { key: 'en', label: 'English', flag: '🇬🇧' }
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const currentLanguage = languages.find(lang => lang.key === i18n.language) || languages[0];

  const handleLanguageChange = async ({ key }) => {
    i18n.changeLanguage(key);

    // Sync language preference to backend if user is logged in
    const token = localStorage.getItem('access_token');
    if (token) {
      try {
        await authService.updateProfile({ preferred_language: key });
      } catch (error) {
        // Silently fail - language is still saved locally
        console.error('Failed to sync language preference:', error);
      }
    }
  };

  const items = languages.map(lang => ({
    key: lang.key,
    label: (
      <span>
        {lang.flag} {lang.label}
      </span>
    )
  }));

  return (
    <Dropdown
      menu={{ items, onClick: handleLanguageChange, selectedKeys: [i18n.language] }}
      trigger={['click']}
      placement="bottomRight"
    >
      <Button type="text" icon={<GlobalOutlined />}>
        {currentLanguage.flag} {currentLanguage.label}
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
